export const SET_CUSTOMER_ADVOCACY_POINTS = 'SET_CUSTOMER_ADVOCACY_POINTS';
export const SET_CUSTOMER_ADVOCACY_POINTS_ERROR = 'SET_CUSTOMER_ADVOCACY_POINTS_ERROR';
export const CUSTOMER_ADVOCACY_BADGES_FETCHING = 'CUSTOMER_ADVOCACY_BADGES_FETCHING';
export const CUSTOMER_ADVOCACY_BADGES_FETCH = 'CUSTOMER_ADVOCACY_BADGES_FETCH';
export const CUSTOMER_ADVOCACY_BADGES_FETCH_ERROR = 'CUSTOMER_ADVOCACY_BADGES_FETCH_ERROR';
